import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-kamona-message-modal',
  templateUrl: './kamona-message-modal.component.html',
  styleUrls: ['./kamona-message-modal.component.scss']
})
export class KamonaMessageModalComponent implements OnInit {

	@Input() title: string;
	@Input() description: string;
	@Output() dismissModal = new EventEmitter ();
  constructor() { }

  ngOnInit(): void {
  }

	dismiss(){
	  this.dismissModal.emit();
	}

}
